import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/i18n";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", restaurant_name: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user && user !== false) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/dashboard", { replace: true });
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-rooftop)] px-6 py-12">
      <div className="absolute inset-0 -z-0 opacity-30">
        <div className="absolute -top-40 -left-40 w-[480px] h-[480px] rounded-full bg-gold/10 blur-3xl" />
      </div>
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="block text-center mb-14 group">
          <span className="font-heading font-extralight text-[1.7rem] sm:text-[2rem] tracking-[0.55em] text-[var(--text-primary)] group-hover:text-[var(--gold)] transition-colors duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]">
            SONARA
          </span>
        </Link>
        <div className="surface-1 rounded-md p-8 animate-fade-up">
          <h1 className="font-heading text-2xl font-light mb-2" data-testid="register-title">{t("auth.register.title")}</h1>
          <p className="text-sm text-[var(--text-muted)] mb-8">{t("auth.register.subtitle")}</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs text-[var(--text-muted)] mb-2 block">{t("common.name")}</label>
              <input type="text" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name-input" className="w-full bg-[#141414] border border-white/10 rounded-md px-4 h-11 text-sm focus:outline-none focus:ring-1 focus:ring-gold transition-all" />
            </div>
            <div>
              <label className="text-xs text-[var(--text-muted)] mb-2 block">{t("auth.register.restaurant_name")}</label>
              <input type="text" value={form.restaurant_name} onChange={(e) => setForm({ ...form, restaurant_name: e.target.value })} data-testid="register-restaurant-input" className="w-full bg-[#141414] border border-white/10 rounded-md px-4 h-11 text-sm focus:outline-none focus:ring-1 focus:ring-gold transition-all" placeholder="Aurora Rooftop" />
            </div>
            <div>
              <label className="text-xs text-[var(--text-muted)] mb-2 block">{t("common.email")}</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email-input" className="w-full bg-[#141414] border border-white/10 rounded-md px-4 h-11 text-sm focus:outline-none focus:ring-1 focus:ring-gold transition-all" />
            </div>
            <div>
              <label className="text-xs text-[var(--text-muted)] mb-2 block">{t("common.password")}</label>
              <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password-input" className="w-full bg-[#141414] border border-white/10 rounded-md px-4 h-11 text-sm focus:outline-none focus:ring-1 focus:ring-gold transition-all" />
            </div>
            {error && <div className="text-xs text-red-400" data-testid="register-error">{error}</div>}
            <button type="submit" disabled={loading} data-testid="register-submit-button" className="w-full btn-primary disabled:opacity-50">
              {loading ? t("common.loading") : t("auth.register.submit")}
            </button>
          </form>

          <p className="text-xs text-[var(--text-muted)] text-center mt-8">
            {t("auth.register.have_account")}{" "}
            <Link to="/login" className="text-gold hover:text-gold-light" data-testid="register-login-link">
              {t("auth.register.login_link")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
